var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-accord-bg-violet';
                    var viewUrl = 'sprite.svg#view-icon-accord-bg-violet';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 74 52',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };